module.exports = __webpack_public_path__ + "images/backgrounds/snow/medium.5c26556f6516fd7ff6bb.jpg";